import React from 'react';
import { Link } from "react-router-dom";
import CaptureItems from '../../containers/CaptureItems';
import { actionsItems, ProjectsItems, cleanupItems } from '../../components/listItems';
import MenuFocus from '../MenuFocus';
import MenuActions from '../MenuActions';

import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';

import { connect } from 'react-redux';





import CalendarMenu from '../CalendarMenu';
const Menu = props => (
    <>
    <Divider />
    <List>
        <CaptureItems isOpenDrawer={props.isOpenDrawer} />
    </List>

    <Divider />
    <List>
        <MenuActions isOpenDrawer={props.isOpenDrawer} />
    </List>

    <Divider />
    <List>
        <MenuFocus isOpenDrawer={props.isOpenDrawer} />
    </List>
    <List>
        <CalendarMenu isOpenDrawer={props.isOpenDrawer}/>    
    </List>
    <Divider />
    <List>
        <ProjectsItems isOpenDrawer={props.isOpenDrawer} />
    </List>
   

    <Divider />
    {/* <List>
        {cleanupItems}
    </List> */}

    {/* <Divider /> */}
    </>
);

const mapStateToProps = (state) => {
    
    return {
      isOpenDrawer: state.isOpenDrawer
    };
  };

export default connect(
  mapStateToProps
)(Menu)
